// import { useId as useReachId } from '@reach/auto-id';
import { useId as useReactId } from 'react';
const AUI_PREFIX = 'asurion-ui';
export const useId = (prefix, id) => {
  const randId = `${AUI_PREFIX}-${prefix}-${useReactId()}`;
  return id ?? randId;
};